import React from 'react';
import { pathOr } from 'ramda';
import { humanizeUTCDateWithoutTimeZone } from 'src/utilities/formatDate';
import { isNotEmpty } from 'src/utilities/hasValue';
import { Link, Box, Divider, MenuItem } from '@mui/material';
import Typography from '@mui/material/Typography';
import ReadIcon from 'src/assets/icons/read-message.svg';
import { getTheme } from 'src/utilities/siteSettings';
const theme = getTheme();

interface Props {
  notification: any;
}
const ReadNotification: React.FC<Props> = (props: Props) => {
  const { notification } = props;
  const redirectTo = pathOr('', ['data', 'redirect_to'], notification);

  return (
    <>
      <Link href={isNotEmpty(redirectTo) ? redirectTo : '#'}>
        <MenuItem
          sx={{
            whiteSpace: 'normal',
            display: 'flex',
            flexDirection: 'column',
            zIndex: 2,
          }}
        >
            <Typography variant="caption" color={theme.palette.gray.extraDarkGray} fontSize={'14px'}>
              {pathOr('', ['data', 'message'], notification)}
            </Typography>
          <Box
            display="flex"
            justifyContent="space-between"
            width="100%"
            alignItems="center"
            mt={'14px'}
          >
            <Link href={isNotEmpty(redirectTo) ? redirectTo : '#'}>
              <Typography variant="caption" color={theme.palette.primaryColor} fontSize={'14px'}>
                Read Message
              </Typography>
            </Link>
            <Typography variant="caption" color={theme.palette.gray.softGray} fontSize={'12px'}>
              {humanizeUTCDateWithoutTimeZone(
                pathOr('', ['created_at'], notification),
                {
                  format: 'ddd, MMM DD, YYYY, h:mm a',
                }
              )}
            </Typography>
            <ReadIcon color={theme.palette.blue.accentBlue} />
          </Box>
        </MenuItem>
      </Link>
      <Divider sx={{ color: theme.palette.lightGray,  margin: '10px 0px'  }} />
    </>
  );
};
export default ReadNotification;
